// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Profession/Detail/index.less
// module id = 922
// module chunks = 0